// extracted by mini-css-extract-plugin
export default {"contentHeader":"ResumeClaimSubmission_contentHeader__AE--E","appleLogo":"ResumeClaimSubmission_appleLogo__E61B2","resumeClaimSB":"ResumeClaimSubmission_resumeClaimSB__jhloD"};